import React, { Component } from 'react'

class SortMenu extends Component {
  constructor(props) {
    super(props)

    this.state = {
      sortBy: props.sortBy && props.sortBy.trim() ? props.sortBy : 'days_online_special',
      sortDir: props.sortDir && props.sortDir.trim() ? props.sortDir : 'asc',
    }
  }

  currentSortOption = () => {
    const { sortBy, sortDir } = this.state

    if (sortBy == 'map_center') {
      return 'map_center'
    } else {
      const dirLabel = sortDir == 'asc' ? 'asc' : null
      return [sortBy, dirLabel].filter(x => x).join(' ')
    }
  }

  handleSortChange = (event) => {
    const [val, dir] = event.target.value.split(' ')
    this.setState({ sortBy: val, sortDir: dir === 'asc' ? 'asc' : 'desc' })
  }

  render() {
    const { sortBy, sortDir } = this.state

    return (
      <div>
        <select value={this.currentSortOption()} style={{marginLeft: 5, marginRight: 15}} onChange={this.handleSortChange}>
          <option value="days_online_special asc">{this.props.saleType === 'Sold' ? 'Recently Sold' : 'Newest Listings'}</option>
          <option value="price">Highest Price</option>
          <option value="price asc">Lowest Price</option>
          <option value="price_change_dts">Price Change</option>
          <option value="bedrooms">Bedrooms</option>
          <option value="bathrooms">Bathrooms</option>
          <option value="sqft">Square Feet</option>
        </select>
        <input type="hidden" name="sort_by" value={sortBy} />
        <input type="hidden" name="sort_dir" value={sortDir} />
      </div>
    )
  }
}

export default SortMenu



// WEBPACK FOOTER //
// client/components/util/SortMenu.js